<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="helpPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="helpPermissionCode" [position]="'inline'" [lang]="currentLang"><span class="icon"><i class="fas fa-user-tag"></i></span>{{ 'RoleMaintenance.Header' | translate }}</h1>
    <p-card>
        <form>
            <div class="p-fluid formgrid grid">
                <div class="field col-6">
                    <label>{{ 'RoleMaintenance.Search.UserType' | translate }}</label>
                    <p-dropdown [(ngModel)]="searchParam.userType" [options]="userTypeOptions" [ngModelOptions]="{standalone: true}"  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>{{ 'RoleMaintenance.Search.RoleCode' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="searchParam.roleCode" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label>{{ 'RoleMaintenance.Search.RoleName' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="searchParam.roleName" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
            <div class="grid">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)"></button>
                    <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick($event)" class="p-button-secondary ml-2"></button>
                    <button pButton pRipple label="{{ 'Common.Button.Add' | translate }}" (click)="openModify($event, 1, null)" class="p-button-help ml-2"></button>
                </div>
            </div>
        </form>
    </p-card>
    <p-table #RoleTable [value]="allRoles" [resizableColumns]="true" [loading]="isLoading" [reorderableColumns]="true" [rowHover]="true" columnResizeMode="expand" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [rows]="5" [rowsPerPageOptions]="[5, 10, 25, 50]"
        [autoLayout]="true" [filterDelay]="0" sortMode="multiple" class="datatable" styleClass="p-datatable-striped">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>{{ 'RoleMaintenance.MainTable.RoleCode' | translate }}</th>
                <th>{{ 'RoleMaintenance.MainTable.RoleName' | translate }}</th>
                <th>{{ 'RoleMaintenance.MainTable.UserType' | translate }}</th>
                <th>{{ 'RoleMaintenance.MainTable.IsActivated' | translate }}</th>
                <th>{{ 'RoleMaintenance.MainTable.Action' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{rowData.roleCode}}</td>
                <td>{{rowData.roleName}}</td>
                <td>{{rowData.userType}}</td>
                <td>{{rowData.isActivated | activated}}</td>
                <td>
                    <i class="pi pi-pencil" (click)="openModify($event, 2, rowData)"></i>
                    <i class="pi pi-file ml-2" (click)="goRolePermission($event, rowData)"></i>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="6" style="text-align: center;">
                    {{ 'Common.Table.NoData' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog header="角色表維護" [(visible)]="displayRoleDialog" appendTo="body" [modal]="true">
        <div class="mb-2">
            <div *ngIf="modifyType == 1" class="p-fluid formgrid grid">
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.UserType' | translate }}</label>
                    <p-dropdown [options]="userTypeOptions" [(ngModel)]="modifyRole.userType" [ngModelOptions]="{standalone: true}" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.RoleCode' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="modifyRole.roleCode" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.RoleName' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="modifyRole.roleName" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.IsActivated' | translate }}</label>
                    <div>
                        <p-inputSwitch class="ml-2" [(ngModel)]="modifyRole.istempActivated"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div *ngIf="modifyType == 2" class="p-fluid formgrid grid">
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.UserType' | translate }}</label>
                    <div>
                        <p-dropdown [(ngModel)]="modifyRole.userType" [options]="userTypeOptions" [ngModelOptions]="{standalone: true}" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
                    </div>
                </div>
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.RoleCode' | translate }}</label>
                    <div>
                        <input pInputText type="text" [(ngModel)]="modifyRole.roleCode" [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.RoleName' | translate }}</label>
                    <div>
                        <input pInputText type="text" [(ngModel)]="modifyRole.roleName" [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
                <div class="field col-6">
                    <label class="title">{{ 'RoleMaintenance.MainTable.IsActivated' | translate }}</label>
                    <div>
                        <p-inputSwitch class="ml-2" [(ngModel)]="modifyRole.istempActivated"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="grid mt-5">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveRole($event)"></button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>
<help-dock
  [permissionCode]="helpPermissionCode"
  [lang]="currentLang">
</help-dock>
